import { PartnerDTO } from 'support/types';
import { PropertyFilter } from 'components/ListTable/types';

import { deepCopy } from '../generic/generic';

export const addPartnersToFiltersConfig = (
  defaultFilterConfig: Array<PropertyFilter>,
  key: string,
  partners?: Array<PartnerDTO>,
): Array<PropertyFilter> => {
  if (!partners) {
    return defaultFilterConfig;
  }

  const newFilterConfig = deepCopy<Array<PropertyFilter>>(defaultFilterConfig); // create deep copy
  const filterIndex = newFilterConfig.findIndex((filter: PropertyFilter) => filter.key === key);

  if (filterIndex > -1) {
    const configDropDownOptions = newFilterConfig[filterIndex].dropDownOptions;

    if (configDropDownOptions) {
      configDropDownOptions.dropdownValues = partners.map((partner: PartnerDTO) => {
        return {
          label: partner.name,
          value: partner.id,
        };
      });
    }
  }

  return newFilterConfig;
};

export type FilterCompoundValue<T extends string> =
  | `${T};${T}`
  | `${T};${T};${T}`
  | `${T};${T};${T};${T}`
  | `${T};${T};${T};${T};${T}`; //limited to 5 values for simplicity
